module.exports = __webpack_public_path__ + "img/settings.dce0b940.svg";